import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faArrowLeft,
    faArrowRight,
    faAngleDoubleLeft,
    faAngleDoubleRight
} from '@fortawesome/free-solid-svg-icons';

const PdfNavigation = ({ currentPage, setCurrentPage, numPdfPages }) => {
    const goToFirstPage = () => {
        setCurrentPage(1);
    };

    const goToPrevPage = () => {
        setCurrentPage((prevCurrentPage) => Math.max(prevCurrentPage - 1, 1));
    };

    const goToNextPage = () => {
        setCurrentPage((prevCurrentPage) => Math.min(prevCurrentPage + 1, numPdfPages));
    };

    const goToLastPage = () => {
        setCurrentPage(numPdfPages);
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '10px 0' }}>
            <button
                className='btn btn-sm btn-secondary'
                onClick={goToFirstPage}
                disabled={currentPage === 1}
            >
                <FontAwesomeIcon icon={faAngleDoubleLeft} /> {/* İlk sayfa simgesi */}
            </button>
            <button
                className='btn btn-sm btn-secondary'
                onClick={goToPrevPage}
                disabled={currentPage === 1}
                style={{ marginLeft: '5px' }}
            >
                <FontAwesomeIcon icon={faArrowLeft} /> {/* Önceki sayfa simgesi */}
            </button>
            <span style={{ margin: '0 10px' }}>
                {currentPage} / {numPdfPages}
            </span>
            <button
                className='btn btn-sm btn-secondary'
                onClick={goToNextPage}
                disabled={currentPage === numPdfPages}
                style={{ marginRight: '5px' }}
            >
                <FontAwesomeIcon icon={faArrowRight} /> {/* Sonraki sayfa simgesi */}
            </button>
            <button
                className='btn btn-sm btn-secondary'
                onClick={goToLastPage}
                disabled={currentPage === numPdfPages}
            >
                <FontAwesomeIcon icon={faAngleDoubleRight} /> {/* Son sayfa simgesi */}
            </button>
        </div>
    );
};

export default PdfNavigation;
